import { useEffect, useState } from "react";
import { http } from "@/lib/api";

export function InterestForm({ defaultCourse = "", light = false, scheduled = false, selfPaced = false }) {
  const [courses, setCourses] = useState([]);
  const [f, setF] = useState({ name: "", email: "", course: defaultCourse });
  const [state, setState] = useState({ busy: false, done: null, err: "" });
  useEffect(() => { http.get("/courses").then((r) => setCourses(r.data)).catch(() => {}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setState({ busy: true, done: null, err: "" });
    try {
      const { data } = await http.post("/courses/interest", { ...f, course: f.course || "undecided" });
      setState({ busy: false, done: data.course, err: "" });
    } catch (er) {
      setState({ busy: false, done: null, err: er?.response?.status === 422 || er?.response?.status === 400 ? "Please enter your name and a valid email address." : "Something went wrong. Please try again in a moment." });
    }
  };

  const txt = light ? "text-[#172A3A]" : "text-[#F5F2E9]";
  const muted = light ? "text-[#647080]" : "text-[#B9C0C9]";
  const field = `w-full px-4 py-3 text-[15px] outline-none border transition-colors ${light ? "bg-white border-[#172A3A]/20 text-[#172A3A] focus:border-[#BDA677]" : "bg-[#172A3A] border-[#2B4053] text-[#F5F2E9] focus:border-[#BDA677]"}`;

  if (state.done) return (
    <div data-testid="interest-success" className={`${txt}`}>
      <div className="font-academic text-2xl font-semibold">You're on the interest list.</div>
      <p className={`${muted} text-sm mt-2 leading-relaxed`}>We'll email you {selfPaced ? `when tuition enrollment for ${state.done} opens` : scheduled ? `about enrollment in ${state.done}` : `when class dates for ${state.done} are announced`}. This is not an enrollment and there is no charge.</p>
    </div>
  );

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="interest-form">
      <input required placeholder="Your name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={field} data-testid="interest-name" />
      <input required type="email" placeholder="Email address" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={field} data-testid="interest-email" />
      <select value={f.course} onChange={(e) => setF({ ...f, course: e.target.value })} className={field} data-testid="interest-course">
        <option value="">Course of interest — not sure yet</option>
        {courses.map((c) => <option key={c.slug} value={c.slug}>{c.code} {c.title}</option>)}
      </select>
      {state.err && <p className="text-[#C97B6B] text-sm" data-testid="interest-error">{state.err}</p>}
      <button disabled={state.busy} className="btn-clay w-full py-3.5 text-[15px] disabled:opacity-60" data-testid="interest-submit">
        {state.busy ? "Joining…" : selfPaced ? "Join the Interest List" : "Join the Live Class Interest List"}
      </button>
      <p className={`${muted} text-xs leading-relaxed`}>{selfPaced ? "Joining is free and is not an enrollment. We'll notify you when tuition enrollment opens." : scheduled ? "Joining is free and is not an enrollment. Andrea Hurley will contact you to confirm a seat in an upcoming class." : "Live classes have not been scheduled yet. Joining is free, is not an enrollment, and simply lets us notify you when dates are announced."}</p>
    </form>
  );
}
